import { getFormValues } from "redux-form";

import UserImage from "src/assets/images/userImage.png";
import { SchedulerWizardFormValues } from "src/interfaces";
import { useAppSelector } from "src/redux/store";
import { translate } from "src/services";
import {
  IconButton,
  IconButtonIcon,
  Image,
  PickupScheduleSummaryCard,
  PickupScheduleSummaryContent,
  PickupScheduleSummaryLeftContent,
  PickupScheduleSummaryRightValue,
  Separator,
  TextDisplay,
  Wrapper,
} from "src/styled";
import { WIZARD_FORM_NAME } from "../AddressForm";
import { useMemo } from "react";
import { every, size } from "lodash";

interface Props {
  displayEditButton: boolean;
  onEditClick: () => void;
}

const ContactSummarySection = ({ displayEditButton, onEditClick }: Props) => {
  const thisFormValues = useAppSelector(
    getFormValues(WIZARD_FORM_NAME)
  ) as SchedulerWizardFormValues;
  const { isSaving } = useAppSelector((state) => state.bulkyItemsScheduler);
  const maxItemsPerRequestReached = useAppSelector(
    (state) => state.bulkyItemsScheduler.errors.maxItemsPerRequestReached
  );

  const disabled = useMemo(() => {
    const hasItems = size(thisFormValues?.items) > 0;

    const eachItemHasDate = every(
      thisFormValues?.items,
      (item) => !!item.pickupDate
    );
    return (
      isSaving || !hasItems || !eachItemHasDate || maxItemsPerRequestReached
    );
  }, [isSaving, maxItemsPerRequestReached, thisFormValues?.items]);

  const displayContactCard =
    thisFormValues?.firstName ||
    thisFormValues?.lastName ||
    thisFormValues?.phoneNumber;

  if (!displayContactCard) return null;

  return (
    <>
      <Wrapper
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <TextDisplay size="medium" color="grayDarker">
          <b>{translate("wizardPage.personalInformation")}</b>
        </TextDisplay>
        {displayEditButton && (
          <IconButton
            type="button"
            color="gray"
            onClick={onEditClick}
            padding="xxSmall small"
            disabled={disabled}
          >
            <IconButtonIcon
              size="medium"
              icon="edit"
              customViewBox="0 0 30 32"
              color="black"
            />

            <TextDisplay size="xSmall" color="black">
              {translate("common.edit")}
            </TextDisplay>
          </IconButton>
        )}
      </Wrapper>
      <Separator height={10} />
      <Wrapper>
        <PickupScheduleSummaryCard hasRightValues={true}>
          <PickupScheduleSummaryRightValue>
            <TextDisplay color="grayDarker" size="xSmall">
              <b>{thisFormValues.phoneNumber || ""}</b>
            </TextDisplay>
          </PickupScheduleSummaryRightValue>
          <PickupScheduleSummaryLeftContent isBig={true}>
            <Image src={UserImage} alt="userImage" />
          </PickupScheduleSummaryLeftContent>
          <PickupScheduleSummaryContent>
            <TextDisplay size="small" color="black">
              <b>{`${thisFormValues.firstName || ""} ${
                thisFormValues.lastName || ""
              }`}</b>
            </TextDisplay>
            <TextDisplay size="xxSmall" color="black" margin="xxSmall no no no">
              {thisFormValues.email || ""}
            </TextDisplay>
          </PickupScheduleSummaryContent>
        </PickupScheduleSummaryCard>
      </Wrapper>
    </>
  );
};

export default ContactSummarySection;
